import { createFeatureSelector, createSelector } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { Settings } from '../settings.state';

import * as Objects from '@core/objects';
// import { FieldDataInterface } from '@core/custom-forms/models/settings/settings-custom-form-field-data.model';
import { SettingsCustomFormFieldData } from "@core/custom-forms/models/settings/settings-custom-form-field-data.class";


export interface EditingForm {
    form: Objects.Form;
    starting_fields: Array<SettingsCustomFormFieldData>; // form db inmutable to check wheter we have to delete an field or not
    fields: Array<SettingsCustomFormFieldData>;
    modified: boolean;
}

export interface FormsStart {
    initialized_forms: boolean;
    initialized_fields: boolean;
}

// in snake style for help to find
interface FormsErrors {
    save_form: HttpErrorResponse;
    save_fields: HttpErrorResponse;
    set_active_form: HttpErrorResponse;
}

export interface SettingsCustomForms {
    starting: FormsStart;
    availables: Array<string>; // set of fields types available defined.
    forms: Array<Objects.Form>;
    editing: EditingForm;
    errors: FormsErrors;
}

export const initialState: SettingsCustomForms = {
    starting: {
        initialized_forms: false,
        initialized_fields: false
    },
    availables: null,
    forms: [],
    editing: {
        form: {
            id: null,
            name: "",
            active: true,
            description: null,
            changed: false
        },
        starting_fields: [],
        fields: [],
        modified: false
    },
    errors: {
        save_form: null,
        save_fields: null,
        set_active_form: null
    }
};


const settingsFeatureSelector = createFeatureSelector('settings');

const settingsFormsFeatureSelector = createSelector(
    settingsFeatureSelector,
    (state: Settings) => state.customForms
);


export const startingSelector = createSelector(
    settingsFormsFeatureSelector,
    (state: SettingsCustomForms) => state.starting
);

export const settingsFormsFormsSelector = createSelector(
    settingsFormsFeatureSelector,
    (state: SettingsCustomForms) => state.forms
);

export const settingsFormsAvailableFieldsSelector = createSelector(
    settingsFormsFeatureSelector,
    (state: SettingsCustomForms) => state.availables
);

export const settingsFormsEditingSelector = createSelector(
    settingsFormsFeatureSelector,
    (state: SettingsCustomForms) => state.editing
);

export const settingsFormsEditingFieldsSelector = createSelector(
    settingsFormsFeatureSelector,
    (state: SettingsCustomForms) => state.editing.fields
);

export const settingsFormsEditingActiveFieldsSelector = createSelector(
    settingsFormsFeatureSelector,
    (state: SettingsCustomForms) => state.editing.fields.filter(f => f.active)
);

export const settingsFormsEditingNextPositionSelector = createSelector(
    settingsFormsFeatureSelector,
    (state: SettingsCustomForms) => {
        // Return the next position, which is maxPosition + 1 if there are active fields, otherwise return 0
        const activeFields = state.editing.fields.filter(f => f.active);
        return activeFields.length > 0 
            ? Math.max(...activeFields.map(af => af.position)) + 1
            : 0;
});

export const settingsFormsEditingModifiedSelector = createSelector(
    settingsFormsFeatureSelector,
    (state: SettingsCustomForms) => state.editing.modified
);

export const errorSelector = (key: string) => 
    createSelector(
        settingsFormsFeatureSelector,
        (state: SettingsCustomForms) => state.errors.hasOwnProperty(key) ? state.errors[key] : null
);

export const awLinkRelatedFieldsSelectors = createSelector(
    settingsFormsFeatureSelector,
    (state: SettingsCustomForms) => state.editing.fields.filter(f => f.active).filter((field: SettingsCustomFormFieldData) => 
      field.type === 'multiple-tag-selector-v1' || field.type === 'single-tag-selector-v1' 
    // field.type === CustomFormFieldTypes.MultipleTagSelectorV1 || field.type === CustomFormFieldTypes.SingleTagSelectorV1
    )
  );